import React from 'react';
import { VendorCTAType, Vehicle } from '../../types';
import { VendorGroupContainer } from './VendorCTAsGroup.style';
import VendorCtaSelector from '../VendorCtaSelector/VendorCtaSelector';
import listOfNonAudiBrands from '../../constants/listOfNonAudiBrands.json';

interface VendorCTAsProps {
  ctas: VendorCTAType[];
  vin: string;
  vehicleId?: string;
  market?: string;
  mainDealer?: string;
  vehicleData: Vehicle;
}

const VendorCTAsGroup: React.FC<VendorCTAsProps> = ({
  ctas,
  vin,
  vehicleId,
  market,
  mainDealer,
  vehicleData,
}) => {
  const {
    bodyType,
    modelMileage,
    modelCode,
    trimName,
    trimline,
    modelYear,
    modelMake,
    modelName,
    modelPrice,
    modelPriceRetail,
    stockNumber,
    typedPrices,
    vehicleType,
    warrantyType,
  } = vehicleData;

  const isCPO = warrantyType === 'used-car-warranty-type.plus';
  const vehicleDataType = vehicleType === 'used' && isCPO ? 'cpo' : vehicleType;
  const vehicleTrim = trimline || trimName;

  const make =
    modelMake === 'Audi'
      ? modelMake
      : listOfNonAudiBrands[modelMake.toUpperCase() as keyof typeof listOfNonAudiBrands].text;

  const model = modelName
    .replace(new RegExp(`${modelYear}\\s*`, 'i'), '')
    .replace(new RegExp(`${make}\\s*`, 'i'), '')
    .trim();

  const dealerPrice = typedPrices.find((element) => element.type === 'dealerPrice');
  const regularPrice = typedPrices.find((element) => element.type === 'regular');

  // used for pre-owned vehicles
  const retailPrice = typedPrices.find((element) => element.type === 'retail');

  const pricingData = (() => {
    if (dealerPrice?.amount && dealerPrice.amount > 0) {
      return dealerPrice.formatted;
    }
    return regularPrice?.formatted;
  })();

  return (
    <>
      <VendorGroupContainer>
        {ctas?.length > 0 &&
          ctas.map((cta: VendorCTAType, index: any) => {
            const buttonVariant = index === 0 ? 'primary' : 'secondary';
            const key = `${index}${ctas?.length}`;

            return (
              <VendorCtaSelector
                key={key}
                ctaDetails={cta}
                variant={buttonVariant}
                vin={vin}
                vehicleId={vehicleId}
                vehicleType={vehicleType}
                market={market}
                mainDealer={mainDealer}
              />
            );
          })}
        <div
          className="vendorIntegrations_vehicleInfo"
          data-body={bodyType}
          data-make={make}
          data-mileage={modelMileage}
          data-model-code={modelCode}
          data-model-number={null}
          data-model={model}
          data-vin={vin}
          data-listed-price={pricingData || retailPrice?.formatted}
          data-retail-price={pricingData || retailPrice?.formatted}
          data-purchase-price={modelPriceRetail}
          data-msrp={modelPrice || '0'}
          data-stock={stockNumber}
          data-trim={vehicleTrim}
          data-type={vehicleDataType}
          data-year={modelYear}
        />
      </VendorGroupContainer>
    </>
  );
};

export default VendorCTAsGroup;
